class CartUpsell extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', this.addItem.bind(this))
    }

    addItem() {

        // console.log(`ADD ${this.dataset.variantId}`)
        const config = {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'X-Requested-With': 'XMLHttpRequest'
            },
        }

        const formData = new FormData();
        formData.append('sections', 'cart-drawer-section')
        
        formData.append(`items[0][id]`, this.dataset.variantId)
        formData.append(`items[0][quantity]`, 1)

        config.body = formData;
        
        const response = fetch('/cart/add.js', config)
        .then((response) => response.json())
        .then(response => {
            const cart_section = response.sections['cart-drawer-section']
            const html = new DOMParser().parseFromString(cart_section, 'text/html');
            document.querySelector('#shopify-section-cart-drawer-section .cart-drawer__content').innerHTML = html.querySelector('.cart-drawer__content').innerHTML
            document.querySelector('.js-cartCount').innerHTML = html.querySelector('#cart-drawer-items').innerText.replace(/[^\d]*/g,'')
            // document.querySelector('.js-cartToggle').click()
        });

    }

    groupedSetSelectorClick(event) {

        const value = event.currentTarget.dataset.value
        const variantIds = event.currentTarget.dataset.variantIds
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)

        this.setAttribute('bundle-label', value)
        this.productName.innerHTML = value
        if(event.currentTarget.dataset.image) {
            document.querySelector('.product-details-top__image__wrapper img').setAttribute('src', event.currentTarget.dataset.image)
        }
        event.currentTarget.closest('.bundle-grouped-set-selector').dataset.variantIds = variantIds
        event.currentTarget.closest('.bundle-grouped-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`

        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
//        this.button.querySelector('.product-buy-options__price').innerHTML = price
//        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
    }
    
    setSelectorClick(event) {
        const value = event.currentTarget.dataset.value
        const variantId = event.currentTarget.dataset.variantId
        event.currentTarget.closest('.bundle-set-selector').dataset.variantId = variantId
        let img = event.currentTarget.querySelector('img')
        if(img) {
            const image = `<img src="${img.src}" height="26" width="26" style="vertical-align:middle">`
            event.currentTarget.closest('.bundle-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
        } else {
            event.currentTarget.closest('.bundle-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
        }
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        // console.log(swatch)
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        const groupProductId = typeof event.currentTarget.dataset.groupProductId != 'undefined' ? event.currentTarget.dataset.groupProductId : null
        console.log(`GI: ${groupProductId}`)
        if(groupProductId) {
            this.switchGallery(groupProductId)
        }
        // here
    }

    groupSelectorClick(event) {
        const url = event.currentTarget.dataset.url
        const value = event.currentTarget.dataset.value
        let img = event.currentTarget.querySelector('img')
        if(img) {
            const image = `<img src="${img.src}" height="26" width="26" style="vertical-align:middle">`
            event.currentTarget.closest('.bundle-group-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
        } else {
            event.currentTarget.closest('.bundle-group-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
        }
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        // console.log(swatch)
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        location.href = url
    }

    optionSelectorRemoveClick(event) {
        event.stopPropagation();
        let done = false
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.closest('.bundle-option-selector').dataset.index
        const valueSelector = event.currentTarget.closest('.option-selector__variant')
        if(this.options.hasOwnProperty(index)) {
            this.options[index].forEach((option, key)=>{
                if(done) {
                    return
                }
                if(option.variantId == variantId) {
                    this.options[index].splice(key, 1)
                    done = true
                    valueSelector.dataset.qty = parseInt(valueSelector.dataset.qty) - 1
                    if(valueSelector.dataset.qty <= 0) {
                        valueSelector.classList.remove('active')
                    }
                }
            })
            if(this.options[index].length <= 0) {
                delete this.options[index]
            }
        }
        this.buyOptions.querySelector('.error-bundle')?.remove()
        this.optionSelectorUpdate()
    }

    optionSelectorClick(event) {

        event.preventDefault()
        event.stopPropagation()
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.closest('.bundle-option-selector').dataset.index
        if(!this.options.hasOwnProperty(index)) {
            this.options[index] = []
        }
        if(variantId) {
            const price = event.currentTarget.dataset.price
            const value = event.currentTarget.dataset.value
            const formatted_price = event.currentTarget.dataset.formattedPrice
            const img = event.currentTarget.querySelector('img')
            const image = img ? `<img src="${img.src}" height="46" width="46">` : null
            this.options[index].push({
                variantId: variantId,
                value: value,
                price: price,
                formattedPrice : formatted_price,
                image: image
            })
            /*
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-variant-id', variantId)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-price', price)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-active', 'true')
            event.currentTarget.closest('.bundle-option-selector').querySelector('.price').innerHTML = `(+${formatted_price})`
            let img = event.currentTarget.querySelector('img')
            if(img) {
                const image = `<img src="${img.src}" height="46" width="46">`
                event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
            } else {
                event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
            }
            event.currentTarget.closest('.bundle-option-selector').querySelectorAll('.option-selector__variant').forEach((selector)=>{
                if(this.options.includes(selector.dataset.variantId)) {
                    selector.classList.add('active')
                } else {
                    selector.classList.remove('active')
                }
            })
            */
        } else {
            /*
            // No clear link
            event.currentTarget.closest('.bundle-option-selector').removeAttribute('data-variant-id')
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-price', 0)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-active', 'false')
            event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = 'Please select'
            event.currentTarget.closest('.bundle-option-selector').querySelector('.price').innerHTML = ''
            event.currentTarget.closest('.bundle-option-selector').querySelectorAll('.option-selector__variant').forEach((selector)=>{
                selector.classList.remove('active')
            })
            */
        }

        this.optionSelectorUpdate()

        const optionsCount = this.optionsCount()

        this.buyOptions.querySelector('.error-bundle')?.remove()

        if(this.hasAttribute('max-options') && (parseInt(this.getAttribute('max-options')) > 0) && (parseInt(this.getAttribute('max-options')) < optionsCount)) {
            this.buyOptions.querySelector('.error-bundle')?.remove()
            const div = document.createElement('div')
            div.classList.add('error-bundle')
            if(parseInt(this.getAttribute('max-options')) > 1) {
                div.innerText = window.themeLabels.errorMaxOptionsPlural.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            } else {
                div.innerText = window.themeLabels.errorMaxOptionsSingular.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            }
            this.buyOptions.prepend(div)
        }
    }

    optionsCount() {
        let count = 0
        for (const key in this.options) {
            if (this.options.hasOwnProperty(key)) {
                count+= this.options[key].length
            }
        }
        console.log(`C: ${count}`)
        return count
    }

    optionSelectorUpdate() {
        document.querySelectorAll('.product-details-top__images .product-details-top__image--small, .product-details-top__images .product-details-top__images__spacer')?.forEach((item)=>{
            item.remove()
        })

        let firstImage = true
        let productPrice = parseFloat(this.querySelector('.product-buy-options__price').dataset.basePrice)
        console.log(`AA: ${productPrice}`)

        this.bundleOptionSelectors.forEach((selector)=>{
            const index = selector.dataset.index
            selector.querySelectorAll('.option-selector__variant').forEach((optionLi)=>{
                optionLi.dataset.qty = 0
            })
            if(this.options.hasOwnProperty(index)) {
                let total = 0,
                    values = [],
                    images = [],
                    formattedPrice = ''
                
                this.options[index].forEach((option)=>{
                    total+= parseFloat(option.price)
                    values.push(option.value)
                    formattedPrice = option.formattedPrice
                    if(option.image) {
                        images.push(option.image)
                        this.addBundleOptionImage(selector, option, firstImage)
                        firstImage = false
                    }
                    const variantSelector = selector.querySelector(`.option-selector__variant[data-variant-id="${option.variantId}"]`)
                    variantSelector.classList.add('active')
                    variantSelector.dataset.qty = parseInt(variantSelector.dataset.qty) + 1
                })

                if(total > 0) {
                    productPrice+= total
                    total = formattedPrice.replace(/[\d.]+/, total)
                    selector.querySelector('.price').innerHTML = `(+${total})`
                } else {
                    selector.querySelector('.price').innerHTML = ``
                }

                // console.log(values)
                if(images.length > 0) {
                    selector.querySelector('.option-selector__toggle__value').innerHTML = `<span class="value-list">${values.join(', ')}</span> ${images.join('')}`
                } else {
                    selector.querySelector('.option-selector__toggle__value').innerHTML = `<span class="value-list">${values.join(', ')}</span>`
                }

            } else {
                // clear selector
                selector.removeAttribute('data-variant-id')
                selector.setAttribute('data-price', 0)
                selector.setAttribute('data-active', 'false')
                selector.querySelector('.option-selector__toggle__value').innerHTML = window.themeLabels.pleaseSelect
                selector.querySelector('.price').innerHTML = ''
                selector.querySelectorAll('.option-selector__variant').forEach((li)=>{
                    li.classList.remove('active')
                    li.dataset.qty = 0
                })
            }
        })

        console.log(productPrice)
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            const oldPriceString = priceEl.innerText;
    // eslint-disable-next-line no-param-reassign
            priceEl.innerHTML = oldPriceString.replace(/[\d.]+/, productPrice);
        })
    }

    addBundleOptionImage(selector, option, firstImage) {
        const variantId = option.variantId
        const variantSelect = selector.querySelector(`.option-selector__variant[data-variant-id="${variantId}"]`)

        if(firstImage) {
            const spacer = document.createElement('hr')
            spacer.classList.add('product-details-top__images__spacer')
            document.querySelector('.product-details-top__images').append(spacer)
        }

        const picture = document.createElement('picture')
        const source1 = document.createElement('source')
        source1.setAttribute('media', '(max-width: 1023px)')
        source1.setAttribute('srcset', variantSelect.dataset.image1)
        picture.append(source1)
        const source2 = document.createElement('source')
        source2.setAttribute('media', '(min-width: 1024px) and (max-width: 1280px)')
        source2.setAttribute('srcset', variantSelect.dataset.image2)
        picture.append(source2)
        const source3 = document.createElement('source')
        source3.setAttribute('media', '(min-width: 1281px) and (max-width: 1600px)')
        source3.setAttribute('srcset', variantSelect.dataset.image3)
        picture.append(source3)
        const source4 = document.createElement('source')
        source4.setAttribute('media', '(min-width: 1601px)')
        source4.setAttribute('srcset', variantSelect.dataset.image4)
        picture.append(source4)
        const img = document.createElement('img')
        img.setAttribute('src', variantSelect.dataset.image)
        picture.append(img)
        const div1 = document.createElement('div')
        div1.classList.add('product-details-top__image','product-details-top__image--small','js-componentDetailsImage')
        const div2 = document.createElement('div')
        div2.classList.add('product-details-top__image__wrapper')
        div1.append(div2)
        const remove = document.createElement('span')
        remove.classList.add('remove')
        remove.dataset.variantId = variantId
        remove.dataset.index = selector.dataset.index
        div2.append(picture)
        div2.append(remove)
        document.querySelector('.product-details-top__images').append(div1)

        remove.addEventListener('click', this.removeOptionClick.bind(this))
    }

    removeOptionClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.dataset.index
        this.bundleOptionSelectors.forEach((selector)=>{
            if(selector.dataset.index == index) {
                selector.querySelector(`.option-selector__variant[data-variant-id="${variantId}"] .remove`)?.click()
            }
        })
    }

    productSelectorClick(event) {
        // console.log(event.currentTarget)
        const productId = event.currentTarget.dataset.productId
        const variantId = event.currentTarget.dataset.variantId
        const value = event.currentTarget.dataset.value
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        // console.log(swatch)
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        this.switchGallery(productId)
    }

    variantSetClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const setIds = event.currentTarget.dataset.setIds
        const value = event.currentTarget.dataset.value
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        event.currentTarget.closest('.variant-set-selector').dataset.setIds = setIds
        if(event.currentTarget.dataset.image) {
            this.productImagePicture.querySelectorAll('source')?.forEach((source, index) => {
                const key = index + 1
                console.log(event.currentTarget.dataset[`image${key}`])
                source.setAttribute('srcset', event.currentTarget.dataset[`image${key}`])
            });
            const img = this.productImagePicture.querySelector('img')
            img.setAttribute('src', event.currentTarget.dataset.image)
            this.productImagePicture.querySelector('button')?.setAttribute('data-image', event.currentTarget.dataset.imageMaster)
        }
        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
        // this.switchGallery(productId)
        this.productName.innerHTML = value
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
    }

    variantFixedSetClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const value = event.currentTarget.dataset.value
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        if(event.currentTarget.dataset.image) {
            this.productImagePicture.querySelectorAll('source')?.forEach((source, index) => {
                const key = index + 1
                console.log(event.currentTarget.dataset[`image${key}`])
                source.setAttribute('srcset', event.currentTarget.dataset[`image${key}`])
            });
            const img = this.productImagePicture.querySelector('img')
            img.setAttribute('src', event.currentTarget.dataset.image)
            this.productImagePicture.querySelector('button')?.setAttribute('data-image', event.currentTarget.dataset.imageMaster)
        }
        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
        // this.switchGallery(productId)
        this.productName.innerHTML = value
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
    }

    switchGallery(productId) {
        const object = document.querySelector(`[type="application/json"]#gallery-json-${productId}`);
        if(!object) {
            return
        }
        const productData = JSON.parse(object.textContent);
        // console.log(productData)
        this.productGallery.innerHTML = ''
        productData.images.forEach((image, index)=>{
            if(index == 0) {
                this.productImagePicture.querySelectorAll('source,img')?.forEach(element => {
                    element.remove()
                });
                image.sources.forEach(data => {
                    const source = document.createElement('source')
                    source.setAttribute('media', data.media)
                    source.setAttribute('srcset', data.srcset)
                    this.productImagePicture.prepend(source)
                });
                const img = document.createElement('img')
                img.setAttribute('src', image.img)
                this.productImagePicture.prepend(img)
                this.productImagePicture.querySelector('button')?.setAttribute('data-image', image.master)
            } else {
                const div = document.createElement('div')
                div.dataset.noStates = true
                div.classList.add('product-gallery__image__wrapper','js-productImage','js-scroll')
                const picture = document.createElement('picture')
                image.sources.forEach(data => {
                    const source = document.createElement('source')
                    source.setAttribute('media', data.media)
                    source.setAttribute('srcset', data.srcset)
                    picture.append(source)
                });
                const img = document.createElement('img')
                img.setAttribute('src', image.img)
                picture.append(img)
                div.append(picture)

                const button = document.createElement('button')
                button.setAttribute('aria-controls', 'pdp-images-zoom')
                button.setAttribute('aria-expanded', 'false')
                button.setAttribute('data-image', image.master)
                button.classList.add('pdp-images__zoom-button','js-zoomOpen')
                const span = document.createElement('span')
                span.classList.add('visually-hidden')
                span.innerText = 'Zoom image'
                button.append(span)
                div.append(button)
                
                this.productGallery.append(div)
            }
        })
    }
}

customElements.define("cart-upsell", CartUpsell);